export default __webpack_public_path__ + "static/media/Trillium-1920px-720px.jpg.bf8ee247.webp";